import { PaginationBar } from 'mailup-web-components'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { getDynamicContentListCallback } from '../../recoil/callbacks/callbacks'
import { resultsState } from '../../recoil/state/page'

const Pagination = () => {
  const intl = useIntl()

  const { pageNumber, pageSize, totalItems } = useRecoilValue(resultsState)

  const getList = useRecoilCallback(getDynamicContentListCallback, [])

  const { current: handleChangePageNumber } = useRef((pageNumber) => {
    getList({ pageNumber })
  })
  const { current: handleChangePageSize } = useRef((pageSize) => {
    getList({ pageSize, pageNumber: 1 })
  })

  return (
    <PaginationBar
      pageNumber={pageNumber}
      pageSize={pageSize}
      totalItems={totalItems}
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' })
      }}
      handleChangePage={handleChangePageNumber}
      handleChangePageSize={handleChangePageSize}
      data-mu-test='pager'
    />
  )
}

export default Pagination
